import { differenceInCalendarDays, format, isValid, parseISO, startOfToday } from "date-fns";

const parseIsoSafe = (iso?: string | null) => {
    if (!iso) return null;
    const d = parseISO(String(iso));
    return isValid(d) ? d : null;
};

export const formatDateRu = (iso?: string | null) => {
    const d = parseIsoSafe(iso);
    if (!d) return "—";
    return format(d, "dd.MM.yyyy");
};

export const getDaysLeft = (iso?: string | null) => {
    const d = parseIsoSafe(iso);
    if (!d) return null;
    return differenceInCalendarDays(d, startOfToday());
};
